export default __webpack_public_path__ + "static/media/1.bcef6c3a.png";